import { productlistConfig } from '../../../config';
import { http } from '../../axios';
import { Pagination } from '../../../../models/Pagination';
import { ProductFilter, ProductsResponseOut } from '../../../store/api';

export interface ParameterTypes {
    pagination: Pagination;
    filterMap: ProductFilter;
}

export const fetchYourTitlesProducts = ({ pagination, filterMap }: ParameterTypes) => {
    return http
        .post<ProductsResponseOut>(productlistConfig().endpointLocalContent, filterMap, {
            params: {
                ...pagination
            },
            pathParams: {
                kind: 'products'
            }
        })
        .then(response => response.data);
};
